<div class="feed feed-voucher h-100">
  <div class="icon-glass">
    <span class="material-icons align-middle">password</span>
  </div>

  <div class="voucher-title">
    <h3 class="text-center">Voucher Code</h3>
    <div class="text-center font-size-14 px-4">Enter a code from one of the screens at the stadium to win a prize</div>
  </div>

  <div class="feed-voucher">
    <div class="input-group">
      <input
        type="text"
        [(ngModel)]="voucherCode"
        aria-labelledby="voucher-label"
        placeholder="ENTER CODE HERE"
        class="form-control text-center code-input"
        (keyup.enter)="redeemVoucher()"
      />
      <div class="input-group-append">
        <button
          class="btn btn-primary form-control voucher-submit bg-primary text-white border-0"
          (click)="redeemVoucher()"
          [disabled]="disableButton"
        >
          <span class="material-icons">chevron_right</span>
        </button>
      </div>
    </div>
    <div class="result-box text-center">
      <div class="result">
        <fgbcl-errors></fgbcl-errors>
        <div class="result-message" *ngIf="redemptionResult">
          {{ redemptionResult }}
        </div>
      </div>
    </div>
  </div>
  <div></div>
</div>
